import { MultiPolygon, Polygon } from "geojson";

import { MaritimeArea as ApiMaritimeArea } from "@/lib/api";
import {
  domainIdFromApiAreaCategory,
  type MaritimeWarningDomainId,
} from "@/lib/maritime-domains";

export type MaritimeArea = {
  id: string;
  name: ApiMaritimeArea["name"];
  domainId: MaritimeWarningDomainId;
  // Non-physical areas (e.g. some seiches locations) have no geometry: the API
  // returns `null`. Only drawable areas can appear on the warnings map.
  geometry: Polygon | MultiPolygon | null;
};

/** Maps API maritime area to app shape. */
export function mapApiMaritimeArea(area: ApiMaritimeArea): MaritimeArea {
  // API may omit area_category on coastal district areas; treat as coastal.
  const areaCategory = area.area_category ?? "coastal";
  const domainId = domainIdFromApiAreaCategory(areaCategory);
  if (!domainId) {
    throw new Error(`Unknown maritime area_category: ${areaCategory}`);
  }

  return {
    id: area.id,
    name: area.name,
    domainId,
    geometry: (area.geometry as Polygon | MultiPolygon | null | undefined) ?? null,
  };
}
